/*
  Franja de Black Friday con cuenta (<site-deals-strip>): el comportamiento de snippets/site-deals-strip.liquid.
  · El final: el de la fila de Flash Deals de la página ([data-pk-end]) o, sin ella, el de la navbar (data-end).
  · Escribe horas (como unidad máxima), minutos y segundos, y las centésimas chicas y arriba (.sds-cs), cada dígito en
    su caja de ancho fijo (.sds-d; los dos puntos, .sds-c), y solo toca los que cambian. Corre por cuadro mientras la pestaña está a la vista; con
    "reducir movimiento", una vez por segundo. "Ends in" aparece con la primera cuenta y se va al llegar a cero.
*/
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

class SiteDealsStrip extends HTMLElement {
  connectedCallback() {
    if (this._on) return;
    const src = document.querySelector('[data-pk-end]');
    const end = Date.parse((src && src.dataset.pkEnd) || this.dataset.end || '');
    this.out = this.querySelector('[data-sds-time]');
    this.right = this.querySelector('[data-sds-r]');
    if (!this.out || !this.right || Number.isNaN(end)) return;
    this.end = end;
    this.cells = [];
    this._on = true;
    this.loop();
  }

  disconnectedCallback() {
    this._on = false;
    cancelAnimationFrame(this._raf);
    clearTimeout(this._t);
  }

  loop() {
    if (!this._on) return;
    const left = this.tick();
    if (!left) return;
    if (reduce.matches || document.hidden) this._t = setTimeout(() => this.loop(), 1000);
    else this._raf = requestAnimationFrame(() => this.loop());
  }

  /* los caracteres del texto: un span por dígito y por separador; se rearma solo si cambia el largo (las horas) */
  tick() {
    /* renovacion cada 24 h: al pasar el fin, salta al dia siguiente (window.u1RollEnd, sections/u1-navbar.liquid) */
    if (this.end <= Date.now() && window.u1RollEnd) this.end = window.u1RollEnd(this.end);
    const ms = Math.max(0, this.end - Date.now());
    if (!ms) {
      this.right.hidden = true;
      return 0;
    }
    const s = Math.floor(ms / 1000);
    const pad = n => String(n).padStart(2, '0');
    const cs = reduce.matches ? '00' : pad(Math.floor((ms % 1000) / 10));
    const main = [Math.floor(s / 3600), pad(Math.floor((s % 3600) / 60)), pad(s % 60)].join(':');
    const text = main + cs;
    if (this.cells.length !== text.length) {
      this.out.replaceChildren();
      const sup = document.createElement('span');
      sup.className = 'sds-cs';
      this.cells = [...text].map((ch, i) => {
        const el = document.createElement('span');
        el.className = ch === ':' ? 'sds-c' : 'sds-d';
        (i < main.length ? this.out : sup).append(el);
        return el;
      });
      this.out.append(sup);
    }
    [...text].forEach((ch, i) => {
      if (this.cells[i].textContent !== ch) this.cells[i].textContent = ch;
    });
    this.right.hidden = false;
    return ms;
  }
}

if (!customElements.get('site-deals-strip')) customElements.define('site-deals-strip', SiteDealsStrip);
